import { assertNonNullable } from "../../utils/asserts";
import { TUserProgramAction, TUserProgramState } from "./types";

export const reducer = (
  state: TUserProgramState,
  action: TUserProgramAction
): TUserProgramState => {
  switch (action.type) {
    case "UPLOAD_DOCUMENT":
      assertNonNullable(state.program);

      return {
        ...state,
        program: {
          ...state.program,
          sections: state.program.sections.map((section) => {
            if (section.title === action.payload.sectionTitle) {
              return {
                ...section,
                documents: [...section.documents, action.payload.document],
              };
            } else {
              return section;
            }
          }),
        },
      };
    case "COMPLETE_TEST":
      assertNonNullable(state.program);

      return {
        ...state,
        program: {
          ...state.program,
          sections: state.program.sections.map((section) => {
            return {
              ...section,
              steps: section.steps.map((step) =>
                step.enabled && step.id === action.payload.stepId
                  ? {
                      ...step,
                      completedOn: new Date().getTime(),
                    }
                  : step
              ),
            };
          }),
        },
      };
    case "START_FETCH_PROGRAM":
      return {
        ...state,
        loading: true,
      };
    case "FETCH_PROGRAM":
      return {
        ...state,
        program: action.payload.program,
      };
    case "FINISH_FETCH_PROGRAM":
      return {
        ...state,
        loading: false,
      };
    case "SUBMIT_HANDOUT_STEP":
      assertNonNullable(state.program);

      return {
        ...state,
        program: {
          ...state.program,
          sections: state.program.sections.map((section) =>
            section.title === action.payload.sectionTitle
              ? {
                  ...section,
                  handoutStepPassed: true,
                }
              : section
          ),
        },
      };

    case "FORM_FILLED":
      assertNonNullable(state.program);

      return {
        ...state,
        program: {
          ...state.program,
          formsFilled: [
            ...(state.program.formsFilled || []),
            action.payload.formId,
          ],
        },
      };
  }
};
